export default __webpack_public_path__ + "static/media/Install 3.9fd56372.jpg";